/**
 * Asset Select Step — top of the asset wizard.
 *
 * Stage 1 of two: render the 6-card asset-type grid. Picking a type
 * sets `formData.assetType` and advances to the hidden `asset-method`
 * step which fans out into Manual / Bulk / Existing.
 */

import { Card, CardContent } from '@g17eco/ui-modern/components/ui/card';
import { ASSET_TYPE_BRANDING } from '../../config/assetTypeBranding';
import { ActivitySelectionCard } from '../ActivitySelectionCard';
import { AssetType } from '../../types/emissions';

interface AssetSelectStepProps {
  initiativeId: string;
  onPickType: (assetType: AssetType) => void;
}

const ALL_TYPES = Object.values(AssetType) as AssetType[];

export const AssetSelectStep = ({ onPickType }: AssetSelectStepProps) => {
  return (
    <Card className='tw:mb-6'>
      <CardContent className='tw:p-6'>
        <h5 className='tw:font-semibold tw:mb-2'>Register a New Asset</h5>
        <p className='tw:text-sm tw:text-muted-foreground tw:mb-6'>
          Select the type of asset you want to track emissions for.
        </p>
        <div className='tw:grid tw:grid-cols-2 tw:md:grid-cols-6 tw:gap-4'>
          {ALL_TYPES.map((type) => {
            const brand = ASSET_TYPE_BRANDING[type] ?? ASSET_TYPE_BRANDING[AssetType.Other];
            return (
              <ActivitySelectionCard
                key={type}
                Icon={brand.Icon}
                iconBg={brand.iconBg}
                iconColor={brand.iconColor}
                label={brand.label}
                description={brand.description}
                onClick={() => onPickType(type)}
              />
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};
